import React, { useEffect, useState } from "react";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import Custom_Paingation from "../../core/BaseComponents/Custom_Paingation";
import { Tooltip, Table, TableHead, TableBody, TableRow, TableCell, TableContainer } from "@mui/material";
import { callAPI } from "../../../axios";
import { getChainIdLS } from "../../../utils/utils";
import BasicModal from "../../core/BaseComponents/Modal";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useSelector } from "react-redux";

export default function ProcessedFailedPending(props) {

  const rowsPerPage = 20;
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);

  const [paginationError, setPaginationError] = useState("");
  const [inputPageValue, setInputPageValue] = useState(1);
  const [fetchNow, setFetchNow] = useState(false)
  const [fetchNowId, setFetchNowId] = useState(-1)
  const [fetchNowSuccessMessage, setFetchNowSuccessMessage] = useState(false)
  const { viewType } = useSelector((state) => state.viewTypeReducer);

  const onPageChange = (event, newPage) => {
    setInputPageValue(newPage);
    setPaginationError("");
    setSelectedPage(newPage);
  };

  const getPageItems = () => {
    const startIndex = (selectedPage - 1) * rowsPerPage;
    const endIndex = Math.min(startIndex + rowsPerPage, props?.list?.length);
    return props?.list?.slice(startIndex, endIndex);
  };

  const triggerFetchNow = (row) => {
    setFetchNow(true)
    setFetchNowId(row?.id)
    callAPI(`/fetch-auto-report?sid=${row?.subscriberId}&cdsn=${row?.cdsn11}`, "GET", {}, { chainId: getChainIdLS() })
      .then(function (response) {
        setFetchNowSuccessMessage(response)
        setFetchNow(false)
        props?.listReport()
        setFetchNowId(-1)
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
        setFetchNow(false)
        setFetchNowId(-1)
      });
  }

  const renderFetchNow = (row) => {
    return (viewType === 'custom' && row?.readyForApkTrigger)? <Tooltip title="All process completed." arrow>
        <img
          src="/Images/succes-icon.png"
          width="25"
          className="ms-3"
        />
      </Tooltip>:(row?.apkInstalled && row?.apkTriggered && row?.readyForApkTrigger && !row?.apkVersionMismatch) ?
      <Tooltip title="All process completed." arrow>
        <img
          src="/Images/succes-icon.png"
          width="25"
          className="ms-3"
        />
      </Tooltip>
      : row.cdsn11.length !== 11 ? <Tooltip title="11 Digit CDSN Not Available" arrow>
        <img
          src="/Images/rotate-blue.png"
          width="25"
          className={`ms-3 opacity-50`}
        />
      </Tooltip> : row?.id === fetchNowId ? <Tooltip title={`${row?.id === fetchNowId ? "Fetch Now in Progress" : "Fetch Now"}`} arrow>
        <img
          // onClick={()=>triggerFetchNow(row)}
          src="/Images/rotate-blue.png"
          width="25"
          className={`${row?.id === fetchNowId ? "loaderIcon" : ""} ms-3 opacity-50`}
        />
      </Tooltip> : <Tooltip title={`${fetchNow ? "Please wait Fetch Now in Progress for another box" : "Fetch Now"}`} arrow>
        <img
          onClick={() => !fetchNow ? triggerFetchNow(row) : ""}
          src="/Images/rotate-blue.png"
          width="25"
          className={`${fetchNow ? "opacity-50" : "cursor-pointer"} ms-3`}
        />
      </Tooltip>
  }

  let columns;

  if (viewType === 'custom') {
    columns = [
      { field: "subscriberId", headerName: "SID", flex: 1 },
      { field: "cdsn11", headerName: "CDSN", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.cdsn11 === "NA" ? row?.cdsn10 : row?.cdsn11}</p> },
      { field: "fwVersion", headerName: "Firmware Version", flex: 1, row: true, renderCell: (row) => <p className={`mb-0 ${row?.fwVersion === "NA" ? 'no-data-mixpannel' : ''}`}>{row?.fwVersion === "NA" ? <>No Data from<br /> Mixpanel</> : row?.fwVersion}</p> },
      { field: "tvAppVersion", headerName: "Tv APP Version", flex: 1, row: true, renderCell: (row) => <p className={`mb-0 ${row?.tvAppVersion === "NA" ? 'no-data-mixpannel' : ''}`}>{row?.tvAppVersion === "NA" ? <>No Data from<br /> Mixpanel</> : row?.tvAppVersion}</p> },
      { field: "kpiVersion", headerName: "KPI Version", flex: 1, row: true, renderCell: (row) => <p className={`mb-0 ${row?.kpiVersion === "NA" ? 'no-data-mixpannel' : ''}`}>{row?.kpiVersion === "NA" ? <>No Data from<br /> Mixpanel</> : row?.kpiVersion}</p> },
      { field: "bouquetName", headerName: "Bouquet Name", flex: 1, row: true, renderCell: (row) => <p className={`mb-0 ${row?.bouquetName === "NA" ? 'no-data-mixpannel' : ''}`}>{row?.bouquetName === "NA" ? <>No Data from<br /> Mixpanel</> : row?.bouquetName}</p> },
      { field: "bouquetId", headerName: "Bouquet ID", flex: 1, row: true, renderCell: (row) => <p className={`mb-0 ${row?.bouquetId === "NA" ? 'no-data-mixpannel' : ''}`}>{row?.bouquetId === "NA" ? <>No Data from<br /> Mixpanel</> : row?.bouquetId}</p> },
      { field: "googleId", headerName: "Google ID", flex: 1, row: true, renderCell: (row) => <p className={`mb-0 ${row?.googleId === "NA" ? 'no-data-mixpannel' : ''}`}>{row?.googleId === "NA" ? <>No Data from<br /> Mixpanel</> : row?.googleId}</p> },
      {
        field: "readyForApkTrigger", headerName: viewType === 'custom' ? <p className="mb-0">Linked With <br /> Hotel</p> : <p className="mb-0">Ready for <br /> APK trigger</p>, flex: 1, row: true, renderCell: (row) => <p className={`text-Left mb-0 ${row?.readyForApkTrigger ? "text-success" : "text-danger"}`}>
          {row?.readyForApkTrigger ? "Yes" : "No"} {(!row?.readyForApkTrigger && row?.info !== null) &&
            <><Tooltip
              title={
                <div className="appPreference table-wrapper table-comparison">
                  <TableContainer className="overflow-x-hidden">
                    <Table size="small" aria-label="parameter comparison table">
                      <TableHead>
                        <TableRow>
                          <TableCell><strong>Parameter Name</strong></TableCell>
                          <TableCell><strong>Expected Value</strong></TableCell>
                          <TableCell><strong>Actual Value</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="hotel-table">
                        {JSON.parse(row?.info)?.map((item) => (
                          <TableRow key={item?.key}>
                            <TableCell>{item?.key}</TableCell>
                            <TableCell>{item?.expected}</TableCell>
                            <TableCell>{item?.actual}</TableCell>
                          </TableRow>
                        )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              }
              arrow
              placement="left"
              PopperProps={{
                className: 'no-bg-tooltip'
              }
              }
            >
              <span className="ms-5">
                <InfoOutlinedIcon
                  style={{ color: "#E20092", height: "16px", marginBottom: "2px" }}
                  className="cursor-pointer"
                />
              </span>
            </Tooltip></>}
        </p>
      },
      { field: "roomNumber", headerName: "Room No", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.roomNumber === null ? "N.A" : row?.roomNumber !== "" ? row?.roomNumber : 'N.A'}</p>, disableSortIcon: true },
      {
        field: 'fetchNow', headerName: 'Fetch Now', flex: 1, row: true, renderCell: renderFetchNow, disableSortIcon: true,
      }
    ];
  } else {
    columns = [
      { field: "subscriberId", headerName: "SID", flex: 1 },
      { field: "cdsn11", headerName: "CDSN", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.cdsn11 === "NA" ? row?.cdsn10 : row?.cdsn11}</p> },
      { field: "fwVersion", headerName: "Firmware Version", flex: 1, row: true, renderCell: (row) => <p className={`mb-0 ${row?.fwVersion === "NA" ? 'no-data-mixpannel' : ''}`}>{row?.fwVersion === "NA" ? <>No Data from<br /> Mixpanel</> : row?.fwVersion}</p> },
      { field: "tvAppVersion", headerName: "Tv APP Version", flex: 1, row: true, renderCell: (row) => <p className={`mb-0 ${row?.tvAppVersion === "NA" ? 'no-data-mixpannel' : ''}`}>{row?.tvAppVersion === "NA" ? <>No Data from<br /> Mixpanel</> : row?.tvAppVersion}</p> },
      { field: "kpiVersion", headerName: "KPI Version", flex: 1, row: true, renderCell: (row) => <p className={`mb-0 ${row?.kpiVersion === "NA" ? 'no-data-mixpannel' : ''}`}>{row?.kpiVersion === "NA" ? <>No Data from<br /> Mixpanel</> : row?.kpiVersion}</p> },
      { field: "bouquetName", headerName: "Bouquet Name", flex: 1, row: true, renderCell: (row) => <p className={`mb-0 ${row?.bouquetName === "NA" ? 'no-data-mixpannel' : ''}`}>{row?.bouquetName === "NA" ? <>No Data from<br /> Mixpanel</> : row?.bouquetName}</p> },
      { field: "bouquetId", headerName: "Bouquet ID", flex: 1, row: true, renderCell: (row) => <p className={`mb-0 ${row?.bouquetId === "NA" ? 'no-data-mixpannel' : ''}`}>{row?.bouquetId === "NA" ? <>No Data from<br /> Mixpanel</> : row?.bouquetId}</p> },
      { field: "googleId", headerName: "Google ID", flex: 1, row: true, renderCell: (row) => <p className={`mb-0 ${row?.googleId === "NA" ? 'no-data-mixpannel' : ''}`}>{row?.googleId === "NA" ? <>No Data from<br /> Mixpanel</> : row?.googleId}</p> },
      {
        field: "readyForApkTrigger", headerName: viewType === 'custom' ? <p className="mb-0">Linked With <br /> Hotel</p> : <p className="mb-0">Ready for <br /> APK trigger</p>, flex: 1, row: true, renderCell: (row) => <p className={`text-Left mb-0 ${row?.readyForApkTrigger ? "text-success" : "text-danger"}`}>
          {row?.readyForApkTrigger ? "Yes" : "No"} {(!row?.readyForApkTrigger && row?.info !== null) &&
            <><Tooltip
              title={
                <div className="appPreference table-wrapper table-comparison">
                  <TableContainer className="overflow-x-hidden">
                    <Table size="small" aria-label="parameter comparison table">
                      <TableHead>
                        <TableRow>
                          <TableCell><strong>Parameter Name</strong></TableCell>
                          <TableCell><strong>Expected Value</strong></TableCell>
                          <TableCell><strong>Actual Value</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="hotel-table">
                        {JSON.parse(row?.info)?.map((item) => (
                          <TableRow key={item?.key}>
                            <TableCell>{item?.key}</TableCell>
                            <TableCell>{item?.expected}</TableCell>
                            <TableCell>{item?.actual}</TableCell>
                          </TableRow>
                        )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              }
              arrow
              placement="left"
              PopperProps={{
                className: 'no-bg-tooltip'
              }
              }
            >
              <span className="ms-5">
                <InfoOutlinedIcon
                  style={{ color: "#E20092", height: "16px", marginBottom: "2px" }}
                  className="cursor-pointer"
                />
              </span>
            </Tooltip></>}
        </p>
      },
      {
        field: "apkTriggered", headerName: <p className="mb-0">APK<br />Pushed</p>, flex: 1, row: true, renderCell: (row) => <p className={`text-Left mb-0 ${row?.apkTriggered ? "text-success" : "text-danger"}`}>
          {row?.apkTriggered ? "Yes" : "No"}
        </p>
      },
      {
        field: "apkInstalled", headerName: <p className="mb-0">APK Installed <br /> on STB</p>, flex: 1, row: true, renderCell: (row) => <p className={`text-Left mb-0 ${row?.apkInstalled ? "text-success" : "text-danger"}`}>
          {row?.apkInstalled ? "Yes" : "No"}
        </p>
      },
      {
        field: "hmsVersionCode", headerName: <p className="mb-0">HMS APK<br />Version</p>, flex: 1, row: true, renderCell: (row) => <p className={`text-Left mb-0 `}>
          {row?.hmsVersionCode ? row?.hmsVersionCode : "N.A"}
        </p>
      },
      {
        field: "stbVersionCode", headerName: <p className="mb-0">STB APK<br />Version</p>, flex: 1, row: true, renderCell: (row) => <p className={`text-Left mb-0 `}>
          {row?.stbVersionCode ? row?.stbVersionCode : "N.A"}
        </p>
      },
      { field: "roomNumber", headerName: "Room No", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.roomNumber === null ? "N.A" : row?.roomNumber !== "" ? row?.roomNumber : 'N.A'}</p>, disableSortIcon: true },
      {
        field: 'fetchNow', headerName: 'Fetch Now', flex: 1, row: true, renderCell: renderFetchNow, disableSortIcon: true,
      }
    ];
  }

  useEffect(() => {
    setTotalPageCount(Math.ceil(props?.list?.length / rowsPerPage) ? Math.ceil(props?.list?.length / rowsPerPage) : 1);
    setPaginationError("")
    setInputPageValue(1)
    setSelectedPage(1);
  }, [props?.list]);

  return (
    <div className={`hotel-list ${getPageItems().length ? 'auto-mode-table' : ''}`}>
      <div className="d-flex justify-content-end">
        {fetchNow && <p className="text-danger my-0">* Fetch Now in Progress. Leaving the page will interrupt current fetch now.</p>}
      </div>
      <TableWrapper
        data={getPageItems()}
        columns={columns}
        noPagination={true}
      />
      <Custom_Paingation
        selectedPage={selectedPage}
        totalPageCount={totalPageCount}
        paginationError={paginationError}
        inputPageValue={inputPageValue}
        setSelectedPage={setSelectedPage}
        setPaginationError={setPaginationError}
        setInputPageValue={setInputPageValue}
        onPageChange={onPageChange}
      />
      <BasicModal
        popupOpen={fetchNowSuccessMessage}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{fetchNowSuccessMessage}</p>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setFetchNowSuccessMessage('') },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
    </div>
  );
}
